import React from 'react';

import { Project, ProjectDescription, Overlay } from './styles';

import PortfolioItemBackground from '../../../assets/portfolio-item-in-page.png';

interface ItemProps {
  firstHeader: string;
  secondHeader: string;
}

const Item: React.FC<ItemProps> = ({
  firstHeader,
  secondHeader,
}: ItemProps) => {
  return (
    <Project>
      <img
        src={PortfolioItemBackground}
        alt={`${firstHeader} ${secondHeader}`}
      />

      <Overlay />

      <ProjectDescription>
        <h1>{firstHeader}</h1>
        <h2>{secondHeader}</h2>
      </ProjectDescription>
    </Project>
  );
};

export default Item;
